import * as Effect from "effect/Effect";
import * as Layer from "effect/Layer";
import * as Stream from "effect/Stream";

import * as ConnectionResolver from "./resolver.ts";
import * as ConnectionDriver from "./driver.ts";
import * as EnvironmentRegistry from "./registry.ts";
import * as PlatformConnectionSource from "../platform/source.ts";
import * as RpcSession from "../rpc/session.ts";
import { ClientTransportResources, trackClientTransportEffect } from "./resources.ts";

const resolverLayer = ConnectionResolver.layer;

const driverLayer = ConnectionDriver.layer.pipe(
  Layer.provide(Layer.mergeAll(resolverLayer, RpcSession.layer)),
);

const registryLayer = EnvironmentRegistry.layer.pipe(Layer.provide(driverLayer));

const connectionStartupLayer = Layer.effectDiscard(
  Effect.gen(function* () {
    const registry = yield* EnvironmentRegistry.EnvironmentRegistry;
    const platformSource = yield* PlatformConnectionSource.PlatformConnectionSource;
    const resources = yield* ClientTransportResources;
    yield* trackClientTransportEffect(
      resources,
      {
        ownerIdentity: "application",
        kind: "fiber",
        identity: "platform-connection-consumer",
        lifetime: "retained-owner",
      },
      trackClientTransportEffect(
        resources,
        {
          ownerIdentity: "application",
          kind: "subscription",
          identity: "platform-connections",
          lifetime: "retained-owner",
        },
        platformSource.changes.pipe(
          Stream.runForEach((change) =>
            change._tag === "InstallHost"
              ? registry.installHost(change.registration)
              : change._tag === "ReplaceHost"
                ? registry.replaceHost(change.registration)
                : registry.removeHost(change.environmentId),
          ),
        ),
        { interruptionReason: "owner-disposal" },
      ),
      { interruptionReason: "owner-disposal" },
    ).pipe(Effect.forkScoped);
  }).pipe(Effect.withSpan("clientRuntime.connection.application.start")),
);

export const layer = connectionStartupLayer.pipe(Layer.provideMerge(registryLayer));
